import { getClientPlatform, invokeNative, isTauri } from "./platform";

export interface AuthTicketBackend {
  platform: "web" | "windows" | "android";
  native: boolean;
  invoke(command: string, args?: Record<string, unknown>): Promise<unknown>;
}

const runtimeBackend = (): AuthTicketBackend => ({
  platform: getClientPlatform(),
  native: isTauri(),
  invoke: invokeNative,
});

export class AuthTicketVault {
  constructor(private readonly backend: AuthTicketBackend = runtimeBackend()) {}

  async load(): Promise<string> {
    if (this.backend.platform === "web" || !this.backend.native) return "";
    const ticket = await this.backend.invoke("load_auth_ticket");
    return typeof ticket === "string" ? ticket : "";
  }

  async save(ticket: string): Promise<void> {
    if (this.backend.platform === "web" || !this.backend.native) return;
    await this.backend.invoke("save_auth_ticket", { ticket });
  }

  async clear(): Promise<void> {
    if (this.backend.platform === "web" || !this.backend.native) return;
    await this.backend.invoke("clear_auth_ticket");
  }
}
